import api from 'api/apiInstance';

export function adviceRoomCancelApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
